import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";

const initialState = {
    isFetching        : false,
    tabelleList       : [],
    showAddField      : false,
    listaCampiTabella : [],
    errorMessage      : null,
    holdingList       : [],
    isAuthenticated   : true
};

const tabellaReducer = (state = initialState, action) => {
    switch (action.type){
        //LISTA DELLE TABELLE
        case actionType.SERVICE_TABELLE_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_TABELLE_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching        : false,
                tabelleList       : typeof action.response === 'undefined' ? [] : action.response,
                isAuthenticated     : action.authenticated || false,
                toRefreshOnRender : false,
                errorMessage      : null
            })
        case actionType.SERVICE_TABELLE_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null
            })
        //AGGIORNA LA LISTA DELLE TABELLE
        case actionType.SERVICE_TABELLE_REFRESH_LIST :
            return Object.assign({}, state, {
                isFetching  : false,
                tabelleList : action.newList
            })
        //MODIFICA UNA TABELLA O NE AGGIUNGE UNA
        case actionType.SERVICE_TABELLE_SET_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_TABELLE_SET_SUCCESS :
            return Object.assign({}, state, {
                isFetching        : false,
                isAuthenticated     : action.authenticated || false,
                toRefreshOnRender : true
            })
        case actionType.SERVICE_TABELLE_SET_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //HOLDING LIST
        case actionType.SERVICE_HOLDING_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_HOLDING_LIST_SUCCESS :
            return Object.assign({}, state, {
              isFetching  : false,
              holdingList : action.response 
            });
        case actionType.SERVICE_HOLDING_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage : action.error || null
            })

        
        //RECUPERO I DATI DELL'UTENTE
        case actionType.SERVICE_USERINFO_REQUEST :
        return Object.assign({}, state, {
            isFetching : true,
        })
        case actionType.SERVICE_USERINFO_SUCCESS :
        var response = action.response;
        //salvo i dati dell'utente
        if(response.hasOwnProperty("IDUser") && response.hasOwnProperty("Username") && response.hasOwnProperty("Role")){
            localStorage.setItem(ROLES.USERINFO_KEY, JSON.stringify(response));
            return Object.assign({}, state, {
                isFetching      : false,
                isAuthenticated : action.authenticated || false,
                userInfo        : response
            })
        }else{
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : false,
            userInfo        : null
            })
        }
        case actionType.SERVICE_USERINFO_ERROR :
        return Object.assign({}, state, {
            isFetching: false,
            errorMessage: action.error || null,
            isAuthenticated: false
        });
        default:
            return state;
    }
};

export default tabellaReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Tabella.js